import { defineStore } from 'pinia'
import DataLayer from '@services/data-layer/index'

// The id stays `nowPlaying`: `state/modules/index.js` camelCased every filename
// into its namespace, so that is what every consumer and persisted key already
// uses. `now-playing` would be a silent rename.
export const useNowPlayingStore = defineStore('nowPlaying', {
    state: () => ({
        byStation: {},
    }),
    getters: {
        currentForStation: state => stationId => (state.byStation[stationId] || [])[0] || null,
    },
    actions: {
        init() {
            DataLayer.stationsPlaylists.subscribe(response => {
                const items = (response && response.body) || []

                this.byStation = items.reduce((byStation, item) => {
                    if (!byStation[item.station]) byStation[item.station] = []
                    byStation[item.station].push(item)
                    return byStation
                }, {})
            })
        },
    },
})
